var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "emailEditor", staticClass: "receivers-list" },
    [
      _vm.isVisible
        ? [
            _c("div", { staticClass: "text-input" }, [
              _c("label", { staticClass: "required-flag" }, [
                _vm._v(_vm._s(_vm.$t("to"))),
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.to,
                    expression: "to",
                    modifiers: { lazy: true },
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  { name: "autosize", rawName: "v-autosize" },
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: Object.assign({}, _vm.buildCheckerOptions(), {
                      required: true,
                    }),
                    expression:
                      "{\n        ...buildCheckerOptions(),\n        required: true,\n        }",
                  },
                ],
                attrs: { required: true },
                domProps: { value: _vm.to },
                on: {
                  change: function ($event) {
                    _vm.to = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-input" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("cc")))]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.cc,
                    expression: "cc",
                    modifiers: { lazy: true },
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  { name: "autosize", rawName: "v-autosize" },
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: Object.assign({}, _vm.buildCheckerOptions(), {
                      required: _vm.cc.trim(),
                    }),
                    expression:
                      "{\n        ...buildCheckerOptions(),\n        required: cc.trim()\n        }",
                  },
                ],
                attrs: { required: _vm.cc.trim() },
                domProps: { value: _vm.cc },
                on: {
                  change: function ($event) {
                    _vm.cc = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-input" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("bcc")))]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.bcc,
                    expression: "bcc",
                    modifiers: { lazy: true },
                  },
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  { name: "autosize", rawName: "v-autosize" },
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: Object.assign({}, _vm.buildCheckerOptions(), {
                      required: _vm.bcc.trim(),
                    }),
                    expression:
                      "{\n        ...buildCheckerOptions(),\n        required: bcc.trim(),\n        }",
                  },
                ],
                attrs: { required: _vm.bcc.trim() },
                domProps: { value: _vm.bcc },
                on: {
                  change: function ($event) {
                    _vm.bcc = $event.target.value
                  },
                },
              }),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }